module.exports = __webpack_public_path__ + "img/logoNA_bb36493587d68d52f5f1693a16160f02.longcache.png";